<template>
  <v-container fluid mt-0 pb-0 pt-0 text-xs-center>
    <div id="printArea">
      <v-layout align-center row wrap>
        <!-- <v-flex xs4>생성일 : {{ results_data.result_date }}</v-flex> -->
        <v-container grid-list-xs>
          <v-layout align-center justify-end>
            <v-flex xs6>생성일 : {{ results_data.timestamp }}</v-flex>
            <v-flex xs3>
              <v-btn small :disabled="isReportGeneratable" @click="result_update()">생성</v-btn>
            </v-flex>
            <v-flex xs3>
              <v-btn fab dark small color="primary" @click="export_report()">
                <v-icon class="icon-flipped">reply</v-icon>
              </v-btn>
            </v-flex>
          </v-layout>
          <v-layout row wrap>
            <v-flex xs12>
              <v-dialog v-model="export_dialog">
                <v-card>
                  <v-card-title>
                    <v-text-field type="text" :value="export_link" id="export_link_id"></v-text-field>
                    <!-- <input type="text" :value="export_link" id="export_link_id" > -->
                  </v-card-title>
                  <v-card-actions>
                    <v-spacer/>

                    <v-alert
                      class="mr-3"
                      style="width: 120px; height:30px;"
                      :value="export_link_copy_done"
                      type="success"
                      transition="scale-transition"
                      outline
                    >복사됨</v-alert>

                    <a :href="export_link" target="_blank" class="mr-3">이동</a>
                    <!-- <v-btn color="primary lighten-2" @click="copy_export_link()">링크 복사</v-btn> -->
                    <!-- <v-btn color="primary lighten-2" data-clipboard-target="#foo" >링크 복사</v-btn> -->
                    <v-btn
                      color="primary lighten-2"
                      @click="export_dialog=false; export_link_copy_done=false;"
                    >닫기</v-btn>
                  </v-card-actions>
                </v-card>
              </v-dialog>
            </v-flex>
          </v-layout>
        </v-container>
        <!-- <v-btn @click="snackbar = true">tttt
        </v-btn>-->
        <v-snackbar v-model="snackbar" :timeout="2000" :color="analysis_request_status" :top="true">
          {{ analysis_request_message }}
          <!-- <v-btn color="blue" flat @click="snackbar = false">Close</v-btn> -->
        </v-snackbar>
        <v-snackbar
          v-model="export_snackbar"
          :timeout="2000"
          :color="export_request_status"
          :top="true"
        >{{ export_request_message }}</v-snackbar>
      </v-layout>
      <!-- <div class="row">
            <div class="col-8">기준일 : {{ results_data.result_date }}</div>
            
            <div class="col-4">tetst</div>
      </div>-->
      <!-- Card Row -->
      <div class="row">
        <!-- Earnings (Monthly) Card Example -->
        <div class="col-xl-3 col-md-3 col-sm-6 col-6 mb-3">
          <div class="card border-left-primary shadow h-100 py-2">
            <div class="card-body">
              <div class="row no-gutters align-items-center">
                <div class="col mr-2">
                  <div class="text-xs font-weight-bold text-primary text-uppercase mb-1">자산</div>
                  <div
                    class="h5 mb-0 font-weight-bold text-gray-800"
                  >{{ this.results_data.summary.asset_amount }} 만원</div>
                </div>
                <div class="col-auto">
                  <i class="fas fa-calendar fa-2x text-gray-300"></i>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- Earnings (Monthly) Card Example -->
        <div class="col-xl-3 col-md-3 col-sm-6 col-6 mb-3">
          <div class="card border-left-success shadow h-100 py-2">
            <div class="card-body">
              <div class="row no-gutters align-items-center">
                <div class="col mr-2">
                  <div class="text-xs font-weight-bold text-success text-uppercase mb-1">부채</div>
                  <div
                    class="h5 mb-0 font-weight-bold text-gray-800"
                  >{{ this.results_data.summary.liability_amount }} 만원</div>
                </div>
                <div class="col-auto">
                  <i class="fas fa-dollar-sign fa-2x text-gray-300"></i>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="col-xl-3 col-md-3 col-sm-6 col-6 mb-3">
          <div class="card border-left-success shadow h-100 py-2">
            <div class="card-body">
              <div class="row no-gutters align-items-center">
                <div class="col mr-2">
                  <div class="text-xs font-weight-bold text-success text-uppercase mb-1">순자산</div>
                  <div
                    class="h5 mb-0 font-weight-bold text-gray-800"
                  >{{ this.results_data.summary.capital_amount }} 만원</div>
                </div>
                <div class="col-auto">
                  <i class="fas fa-dollar-sign fa-2x text-gray-300"></i>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- Earnings (Monthly) Card Example -->
        <div class="col-xl-3 col-md-3 col-sm-6 col-6 mb-3">
          <div class="card border-left-success shadow h-100 py-2">
            <div class="card-body">
              <div class="row no-gutters align-items-center">
                <div class="col mr-2">
                  <div class="text-xs font-weight-bold text-success text-uppercase mb-1">총손익</div>
                  <div
                    class="h5 mb-0 font-weight-bold text-gray-800"
                  >{{ this.results_data.summary.profit_amount }} 만원</div>
                </div>
                <div class="col-auto">
                  <i class="fas fa-dollar-sign fa-2x text-gray-300"></i>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- Flow Row -->
      <v-divider></v-divider>
      <div class="row">
        <div class="col-xl-12 col-lg-12">
          <div class="card shadow">
            <div class="card-header py-3">
              <h6 class="m-0 font-weight-bold text-primary">자산 내역</h6>
            </div>
            <div class="card-body pa-0">
              <v-card>
                <template>
                  <v-data-table
                    :headers="headers"
                    :items="position_list"
                    hide-actions
                    class="elevation-0"
                  >
                    <template slot="items" slot-scope="props">
                      <td>{{ props.item.name }}</td>
                      <td class="text-xs-left">{{ props.item.book_value }}</td>
                      <td class="text-xs-left">{{ props.item.book_date }}</td>
                      <td class="text-xs-left">{{ props.item.apt_name }}</td>
                      <td class="text-xs-left">
                        <v-progress-linear value="50" height="5" :color="props.item.color"></v-progress-linear>
                      </td>
                      <td class="text-xs-right">
                        <v-btn flat icon color="grey">
                          <v-icon>edit</v-icon>
                        </v-btn>
                      </td>
                    </template>
                  </v-data-table>
                </template>
              </v-card>
            </div>
          </div>
        </div>
      </div>

      <v-divider></v-divider>

      <div class="row">
        <div class="col-xl-12 col-lg-12">
          <div class="card shadow">
            <div
              class="card-header py-3 d-flex flex-row align-items-center justify-content-between"
            >
              <h6 class="m-0 font-weight-bold text-primary">현금흐름</h6>
            </div>
            <div class="card-body">
              <div class="chart-area">
                <!-- <line-chart :chartdata="chartData"></line-chart> -->
                <!-- <bar-example></bar-example> -->
                <canvas ref="myChart"></canvas>
              </div>
            </div>
          </div>
        </div>
      </div>

      <v-divider></v-divider>

      <!-- Comment Row -->
      <div class="row">
        <!-- Content Column -->
        <div class="col-lg-6">
          <!-- Approach -->
          <div class="card shadow">
            <div class="card-header py-3">
              <h6 class="m-0 font-weight-bold text-primary">메모</h6>
            </div>
            <div class="card-body">
              <p>
                SB Admin 2 makes extensive use of Bootstrap 4 utility classes in order to reduce CSS bloat
                and poor page performance. Custom CSS classes are used to create custom components and
                custom utility classes.
              </p>
              <p class="mb-0">
                Before working with this theme, you should become familiar with the Bootstrap
                framework, especially the utility classes.
              </p>
            </div>
          </div>
        </div>
      </div>

      <hr>

      <!-- <div class="row">
        <v-container>
            <v-layout row wrap>
                <v-flex xs12 mb6>
                    <v-text-field label="Email" v-model="userinfo.email"></v-text-field>
                </v-flex>        
                <v-flex xs12 mb6>
                    <v-btn color="primary" @click='store_position()'>Save
                        
                    </v-btn>
                    <v-btn color="primary" @click='printDiv()'>Print
                        
                    </v-btn>
                </v-flex>
            </v-layout>
        </v-container>

      </div>-->
    </div>
  </v-container>
</template>

<script>
import Chart from "chart.js";
import sha256 from "js-sha256";
export default {
  props: ["results_data", "userinfo", "position_list"],
  data() {
    return {
      position_stored: false,
      snackbar: false,
      analysis_request_status: "info",
      analysis_request_message: "no message",
      export_snackbar: false,
      export_link: "",
      export_link_copy_done: false,
      export_dialog: false,
      export_request_status: "info",
      export_request_message: "no message",
      headers: [
        {
          text: "Name",
          align: "left",
          value: "name"
        },
        {
          text: "Price",
          value: "price"
        },
        {
          text: "Date",
          value: "date"
        },
        {
          text: "AptName",
          value: "apt_name"
        },
        {
          text: "Ratio",
          value: "ratio"
        },
        {
          text: "Action",
          value: "action",
          align: "right"
        }
      ],
      cashflow_chart: null,
      chartData: {
        datacollection: {
          labels: ["January", "February"],
          datasets: [
            {
              label: "Data One",
              backgroundColor: "#f87979",
              data: [40, 21]
            }
          ]
        }
      },
      options: {
        responsive: true,
        maintainAspectRatio: false
      }
    };
  },
  mounted: function() {
    var this_component = this;

    if (!this.$store.state.isCalculated) {
      // this.result_update(); -> empty result로 우선 만들음
      //console.log('report_vue mounted');
      //console.log(this.cashflows_data.options);
      //console.log(this.results_data.flows.inflows);
      //console.log(this.results_data.flows.outflows);
      this.chart = new Chart(this.$refs.myChart, {
        type: "bar",
        data: {
          labels: this.results_data.flows.dates,
          datasets: [
            {
              label: "In",
              backgroundColor: "blue",
              data: this.results_data.flows.inflows
            },
            {
              label: "out",
              backgroundColor: "red",
              data: this.results_data.flows.outflows
            }
          ]
        }
      });
      // this.renderChart(this.chartdata.datacollection, this.chartdata.options);
    }

    var element = document.getElementById("export_link_id");
    element.addEventListener(
      "focus",
      function(event) {
        event.preventDefault();
        this.select();
        var clipboardInputs = new ClipboardJS(this, {
          target: function(trigger) {
            return trigger;
          }
        });
        clipboardInputs.on("success", function(ev) {
          //console.log("Copied text to clipboard");
          this_component.export_link_copy_done = true;
        });
      },
      true
    );
  },
  methods: {
    copy_export_link() {
      /* Get the text field */
      // //var copyText = document.getElementById("export_link_id");
      // var copyText = document.getElementById("export_link_id");
      // console.log('test')
      // /* Select the text field */
      // copyText.select();
      // /* Copy the text inside the text field */
      // document.execCommand("copy");
      // this.analysis_request_message = "링크 복사 완료";
      // this.analysis_request_status = "success";
      // this.snackbar = true;
    },
    export_report() {
      var this_component = this;
      this.snackbar = false;
      this.export_link_copy_done = false;
      var position_token = this.$store.getters.getCookie("position_token");
      //console.log(this_component.results_data.toString());
      var report_token = sha256(this_component.results_data.toString());
      this.$axios
        .post(this.$store.state.url_end_point + "/export_report", {
          report_token: report_token,
          position_token: position_token,
          results_data: this_component.results_data
        })
        .then(function(response) {
          // console.log(response.data);
          // pop up
          this_component.export_dialog = true;
          var link =
            this_component.$store.state.url_end_point +
            "/report/" +
            report_token;
          this_component.export_link = link;
          // console.log(link);
          //           this_component.$copyText(link).then(function (e) {
          //           this_component.export_snackbar = true;
          //               this_component.export_request_status = "success";
          //               this_component.export_request_message = "링크 복사 완료";
          //         }, function (e) {
          //           console.log(e);
          //              this_component.snackbar = true;
          //             this_component.analysis_request_status = 'error';
          //             this_component.analysis_request_message = "링크 복사 실패";
          //         });
        })
        .catch(function(error) {
          console.log(error);
          this_component.snackbar = true;
          this_component.analysis_request_status = "error";
          this_component.analysis_request_message = "링크 복사 실패";
        });
    },
    result_update() {
      var this_component = this;
      this.snackbar = false;
      var position_token = this.$store.getters.getCookie("position_token");
      this.$axios
        .post(this.$store.state.url_end_point + "/analysis", {
          email: this.$store.state.userinfo.email,
          position_token: position_token,
          position_list: this.$store.state.selected_portfolio.position_list
        })
        .then(function(response) {
          // console.log(response.data);
          this_component.$store.state.results_data = response.data.results_data;
          this_component.$store.state.isCalculated;
          this_component.analysis_request_message = "success";
          this_component.analysis_request_status = "success";
          this_component.snackbar = true;
          // console.log(this_component.$store.state.results_data);
        })
        .catch(function(error) {
          if (error.response.status == 400) {
            this_component.snackbar = true;
            console.log(error.response.message);
            this_component.analysis_request_message = this.response.message;
            this_component.analysis_request_status = "error";
          }
          console.log(error);
        });
    },
    printDiv() {
      // var divName = 'printArea';
      // var printContents = document.getElementById(divName).innerHTML;
      // var originalContents = document.body.innerHTML;
      // document.body.innerHTML = printContents;
      this.isHeaderVisible = false; // 동작안함. rendering이 함수 끝나고 됨.
      window.print();
      this.isHeaderVisible = true;
      // document.body.innerHTML = originalContents;
    }
  },
  computed: {
    isHeaderVisible: {
      get: function() {
        return this.$store.state.isHeaderVisible;
      },
      set: function(p) {
        this.$store.state.isHeaderVisible = p;
      }
    },
    isReportGeneratable: {
      get: function() {
        return this.position_list.length == 0;
      }
    }
    // position_list() {
    //     return this.$store.state.position_list;
    // },
  },

  beforeDestroy() {
    // Don't forget to destroy the Chart.js instance.
    if (this.cashflow_chart) {
      this.cashflow_chart.destroy();
    }
  }
};
</script>

<style lang="css" scoped>
.icon-flipped {
  -o-transform: scaleX(-1);
  -moz-transform: scaleX(-1);
  -webkit-transform: scaleX(-1);
  -ms-transform: scaleX(-1);
  transform: scaleX(-1);
}
</style>

